import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';

@Component({
  selector: 'page-setting',
  templateUrl: 'setting.html'
})
export class SettingPage {
  private data = {
    savedCreds: false
  };

  constructor(public navCtrl: NavController) {
    this.initializeCredSetting();
  }

  initializeCredSetting() {
    let crdLocalStorage = localStorage.getItem("__crd__");
    let crdSessionStorage = sessionStorage.getItem("__crd__");

    if (crdLocalStorage == null) {
      this.data.savedCreds = false;
    }
    else {
      let crdLocalStorageParsed = JSON.parse(crdLocalStorage);
      let crdSessionStorageParsed = JSON.parse(crdSessionStorage);

      if (crdLocalStorageParsed.email == crdSessionStorageParsed.email) {
        if (crdLocalStorageParsed.password == crdSessionStorageParsed.password) {
          this.data.savedCreds = true;
        }
        else { this.data.savedCreds = false; }
      }
      else { this.data.savedCreds = false; }
    }
  };

  saveCredsChanged() {
    if (this.data.savedCreds) {
      let crd = sessionStorage.getItem("__crd__");
      let parsedCrd = JSON.parse(crd);
      localStorage.setItem("__crd__", JSON.stringify(parsedCrd));
    }
    else {
      localStorage.removeItem("__crd__");
    }
  };
}


// WEBPACK FOOTER //
// ./src/pages/setting/setting.ts